import classnames from "classnames";
import { IFeature as GeoJSFeature } from "@geo/js";
import * as React from "react";
import { useSearchContext } from "../../Contexts/SearchContext";

const strings = { defaultDisplayValue: "Vērtība nav ievadīta" };

export const FeatureList = ({ features, id }: { features: GeoJSFeature[]; id: string }): JSX.Element => {
    const { selected, setSelected } = useSearchContext();

    const onFeatureClick = (feature: any) => setSelected(feature);

    return (
        <>
            {features.map((feature: any, i) => {
                const key = id + "_" + feature.get("label") + i;
                const classNames = classnames("search-result-feature", {
                    "selected-feature":
                        selected && selected.feature && selected.feature.get("OBJECTID") === feature.get("OBJECTID")
                });

                return (
                    <div key={key} className={classNames} onClick={() => onFeatureClick(feature)}>
                        <div>{feature.get("label") || strings.defaultDisplayValue}</div>
                    </div>
                );
            })}
        </>
    );
};
